import { useRef, useState } from "react";
import NavBar from "../NavBar";
import InputBox from "../InputBox";

const Dashboard2 = () => {
  const [messages1, setMessages1] = useState([]);
  const [messages2, setMessages2] = useState([]);
  const chat1 = useRef(null);
  const chat2 = useRef(null);
  const [isHeaderExpand, setIsHeaderExpand] = useState(false);

  return (
    <>
      <div className={"flex flex-col"}>
        <NavBar setIsHeaderExpand={setIsHeaderExpand} />
        <div className="bg-primary text-primary">
          <div
            className={`flex justify-center items-center md:h-[calc(100vh-64px)] ${
              isHeaderExpand ? "h-[calc(100vh-124px)]" : "h-[calc(100vh-64px)]"
            }`}
          >
            <div className="flex flex-col items-center sm:w-3/4 w-full h-full p-8 pt-4 rounded-lg">
              <div className="grid grid-cols-2 gap-4 w-full mb-4 flex-grow overflow-y-auto">
                <div ref={chat1} className="chat overflow-y-auto">
                  <h1 className="text-3xl">HEY hey2</h1>
                  {messages1.map((message, index) =>
                    message.sender === "assistant" ? (
                      message.text
                    ) : (
                      <span key={index}>
                        <div className="you" />
                        <b>You</b>:{" "}
                        <span className={`message ${message.sender}`}>
                          {message.text}
                        </span>
                        <div className="ai" />
                        <b>AI</b>:{" "}
                      </span>
                    )
                  )}
                </div>
                <div ref={chat2} className="chat overflow-y-auto">
                  <h1 className="text-3xl">AI 2</h1>
                  {messages2.map((message, index) =>
                    message.sender === "assistant" ? (
                      message.text
                    ) : (
                      <span key={index}>
                        <div className="you" />
                        <b>You</b>:{" "}
                        <span
                          key={index}
                          className={`message ${message.sender}`}
                        >
                          {message.text}
                        </span>
                        <div className="ai" />
                        <b>AI</b>:{" "}
                      </span>
                    )
                  )}
                </div>
              </div>

              <InputBox
                messages1={messages1}
                setMessages1={setMessages1}
                messages2={messages2}
                setMessages2={setMessages2}
                chat1={chat1}
                chat2={chat2}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Dashboard2;
